import { render, staticRenderFns } from "./MyLandownerReports.vue?vue&type=template&id=64c175bc"
import script from "./MyLandownerReports.vue?vue&type=script&lang=js"
export * from "./MyLandownerReports.vue?vue&type=script&lang=js"
import style0 from "./MyLandownerReports.vue?vue&type=style&index=0&id=64c175bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports